import {Component, OnInit, ViewChild} from '@angular/core';
import {Route} from '../../enum/route';
import {ProposalDetailPageActions} from '../../store/proposal/actions/proposal.actions';
import {ActivatedRoute, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {ProposalAppState} from '../../store/proposal/reducers/proposal.reducer';
import {
  selectDetailPageOffers,
  selectDetailPageProposal,
  selectDetailPageProposalTile,
  selectLoading
} from '../../store/proposal/selectors/proposal.selectors';
import {UserService} from '../../services/user/user.service';
import {filter, map, Observable, Subject, takeUntil} from 'rxjs';

import {OfferStatus} from '../../enum/offer-status';
import {Offer} from '../../model/offer/offer';
import {Roles} from '../../enum/roles';
import {User} from '../../model/user';
import {
  ExternalCoverageComponent
} from '../../components/proposal-details-components/offers-list-tab/external-coverage/external-coverage.component';

@Component({
    selector: 'app-create-offer',
    templateUrl: './create-external-coverage.component.html',
    styleUrls: ['../../../styles/create-something.scss', '../../../styles/standard-elements.scss', './create-external-coverage.component.scss'],
    standalone: false
})
export class CreateExternalCoverageComponent implements OnInit {
  Route = Route;

  proposal$ = this.proposalStore.select(selectDetailPageProposal);

  loading$ = this.proposalStore.select(selectLoading);
  proposalTile$ = this.proposalStore.select(selectDetailPageProposalTile);
  protected destroy$ = new Subject<void>();

  private readonly roles: Roles[];
  user: User;

  uploadInProgress: boolean = false;


  offers$: Observable<Offer[]> = this.proposalStore.select(selectDetailPageOffers)
    .pipe(
      filter(offers => offers != null),
      map(offers => offers
        .filter(offer =>
          (offer.creator.id == this.user.id)
          || (this.roles.includes(Roles.ROLE_BROKER)
            || (this.roles.includes(Roles.ROLE_UNDERWRITER)))
        )));
  hasLead$: Observable<boolean> = this.offers$
    .pipe(map(offers => offers.filter(offer => offer.status == OfferStatus.ACCEPTED && offer.isLeading).length > 0));


  @ViewChild(ExternalCoverageComponent) externalCoverageComponent: ExternalCoverageComponent;


  constructor(private readonly activatedRoute: ActivatedRoute,
              private readonly router: Router,
              readonly userService: UserService,
              public readonly proposalStore: Store<ProposalAppState>,
  ) {
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      if (params['id'] == null) {
        this.router.navigate(['/' + Route.INSERATE]);
      } else {
        let proposalId: string = params['id'];
        this.proposalStore.dispatch(ProposalDetailPageActions.load({proposalId: proposalId}));
      }
    });
  }


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  cancel() {
    this.router.navigate(['/' + Route.INSERATE]);
  }

  back() {
    this.proposal$.pipe(takeUntil(this.destroy$)).subscribe((proposal) =>
      this.router.navigate(['/' + Route.PROPOSAL_DETAILS, proposal.proposalInformation.id]));
  }


  navigateToUserProfile() {
    this.proposal$.subscribe((proposal) => {
      this.router.navigate([Route.USER_PAGE, proposal.creator.id]);
    });

  }

  submit() {
    this.externalCoverageComponent.navigateToPreview();
  }

  receiveUploadStatus(status: boolean) {
    this.uploadInProgress = status;
  }
}
